import * as styles from './index.css';

import leadformHeads from './leadform_heads.webp';

const LeadFormHeadsImage = ({ centered = false }: { centered?: boolean }) => (
  <img
    alt="cartoon heads"
    className={centered ? styles.leadFormHeadsImageCentered : styles.leadFormHeadsImageRight}
    fetchPriority="high"
    height={leadformHeads.height}
    loading="eager"
    src={leadformHeads.src}
    width={leadformHeads.width}
  />
);

export default LeadFormHeadsImage;
